import { Action } from './action';

export class Competence {
    id: number;
    titre: string;
    definition: string;
    actions: Action[];
    checked: boolean;
}
